import React from "react";

type Props = {
  title: string;
  value: string | JSX.Element;
  includeColon?: boolean;
  valueBold?: boolean;
  className?: string;
};

const InfoItemInline = ({
  title,
  value,
  includeColon = false,
  valueBold = true,
  className,
}: Props) => {
  return (
    <div
      className={`d-flex justify-content-between${
        className ? ` ${className}` : ""
      }`}
    >
      <div className={`text-muted`}>
        {title}
        {includeColon ? ":" : ""}
      </div>
      <div className={valueBold ? "font-weight-bold" : undefined}>{value}</div>
    </div>
  );
};

export default InfoItemInline;
